import load from 'loadjs';
import React, { Children } from 'react'
import { render } from 'react-dom'
import { Provider } from 'mobx-react'

import Store from '~src/store'
import ErrorBoundary from '~src/core/services/exceptions/ErrorBoundary'

export const ELEMENT_SELECTOR = '[data-component="stripe-payment-button"]'

const elements = document.querySelectorAll(ELEMENT_SELECTOR)

if (!!elements) {
  load('https://js.stripe.com/v3/', {returnPromise: true})
    .then(() => {
      elements.forEach(element => {
        System.import(
          // this causes webpack to create a new output file of this name
          /* webpackChunkName: "component__strip-payment-button" */
          './StripePaymentButtonComponent')
          .then(({ default: StripePaymentButtonComponent }) => {
            render(
              <Provider store={Store}>
                <ErrorBoundary>
                  <StripePaymentButtonComponent
                    {...element.dataset}
                    className={Array.from(element.classList || []).join(' ')}
                    label={element.innerHTML}
                  >
                  </StripePaymentButtonComponent>

                </ErrorBoundary>
              </Provider>,
              element.parentElement)
          })
      })

    })
}


